import { IApiPrice, IApiPriceData } from '@cbridge-packages/api-conversion';
import { ISymbolPrice, ISymbolPriceData } from './symbolPrice.interface';

export namespace SymbolPriceTranslator {
  function fromApiPriceData(data?: IApiPriceData): ISymbolPriceData | undefined {
    if (!data) return undefined;

    return {
      bid: data.bid,
      ask: data.ask,
      timestamp: data.timestamp,
    };
  }

  export function fromApi(price: IApiPrice): ISymbolPrice {
    return {
      symbolId: price.symbolId,
      name: price.name,
      manual: fromApiPriceData(price.manual),
      system: fromApiPriceData(price.system),
    };
  }
}
